// Lokalni filter lista proizvoda na stranici (bez poziva API-ja).
// Polje <ListFilter /> upisuje upit u zajednicko stanje, a liste na stranici (TopOther, TopPriceBase,
// TopPriceBlock i liste u stranicama) prikazuju samo stavke koje odgovaraju. Prazan upit = nista se ne menja.

const DIACRITICS: Record<string, string> = { š: 's', đ: 'dj', ž: 'z', č: 'c', ć: 'c' }

// mala slova, bez kvacica i znakova: "Šljive (suva)" -> "sljive suva"
export const normalizeText = (value: unknown): string =>
  String(value ?? '')
    .toLowerCase()
    .replace(/[šđžčć]/g, (m) => DIACRITICS[m])
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()

// lagano svodjenje na koren za padezne nastavke: jabuke, jabuka, jabukama -> jabuk
// (isto pravilo kao u API pretrazi)
export const stemWord = (word: string): string => {
  for (const suffix of ['ovima', 'evima', 'ama', 'ima', 'ove', 'eve', 'om', 'em', 'og', 'oj', 'eg', 'im']) {
    if (word.endsWith(suffix) && word.length - suffix.length >= 4) {
      word = word.slice(0, -suffix.length)
      break
    }
  }

  if (word.length >= 4 && 'aeiou'.includes(word.slice(-1))) {
    word = word.slice(0, -1)
  }

  return word
}

export const useListFilter = () => {
  const term = useState<string>('list-filter-term', () => '')

  const words = computed(() =>
    normalizeText(term.value)
      .split(' ')
      .filter(Boolean)
      .map(stemWord)
  )

  const active = computed(() => words.value.length > 0)

  // svaka reci iz upita mora da se nalazi u tekstu
  const match = (text: unknown): boolean => {
    if (!active.value) return true

    const normalized = normalizeText(text)

    return words.value.every((word) => normalized.includes(word))
  }

  return { term, active, match }
}

// Broj prikazanih stavki po listi na stranici: sluzi za poruku "nema rezultata" kad nijedna lista nema pogodak.
export const useListFilterHits = (count: Ref<number>, enabled: boolean = true) => {
  // liste bez filtera se ne racunaju (inace bi poruka "nema rezultata" nikad ne bi izasla)
  if (!enabled) return

  const id = useId()
  const hits = useState<Record<string, number>>('list-filter-hits', () => ({}))

  // prati samo broj; citanje hits unutar callback-a se ne prati (inace bi efekat pokretao sam sebe)
  watch(count, (value) => {
    hits.value = { ...hits.value, [id]: value }
  }, { immediate: true })

  onBeforeUnmount(() => {
    const { [id]: _removed, ...rest } = hits.value
    hits.value = rest
  })
}
